module.exports = __webpack_public_path__ + "static/img/WX20180907-003937@2x.694ec40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WX20180907-003937@2x.png
// module id = EpHU
// module chunks = 2